"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrightcoveVideo = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var video_js_1 = tslib_1.__importDefault(require("video.js"));
require("vendors/videojs/video-js.css");
// @ts-ignore
var brightcove_service_1 = tslib_1.__importDefault(require("../../../../markups/hbs/scripts/services/brightcove-service"));
// @ts-ignore
var cloudinary_1 = tslib_1.__importDefault(require("../../../../markups/hbs/scripts/utils/cloudinary"));
require("./BrightcoveVideo.less");
require("./styles.less");
var getPoster = function (image, vjsPlayer) {
    return cloudinary_1.default.getCloudinaryPath(image.identifier, Math.floor(vjsPlayer.currentDimension('width')), Math.floor(vjsPlayer.currentDimension('height')), image.cropMode || 'fill', null, image.gravity);
};
var patchMeta = function (meta) {
    var sources = meta.sources
        .filter(function (_a) {
        var src = _a.src;
        return src.startsWith('https');
    })
        .sort(function (src1, src2) {
        if (src1.avg_bitrate === src2.avg_bitrate) {
            return 0;
        }
        // sometimes type is application/x-mpegURL and it is
        // not supported by mobile devices and haven't bitrate
        if (!src2.avg_bitrate) {
            return -1;
        }
        return src1.avg_bitrate > src2.avg_bitrate ? -1 : 1;
    });
    return tslib_1.__assign(tslib_1.__assign({}, meta), { sources: sources });
};
// TODO: Workaround to allow captions menu works
var captionsDivListener = function (event) {
    var component = event.target.querySelector('.vjs-menu');
    if (component) {
        component.style.display = 'block';
        component.classList.remove('vjs-hidden');
    }
};
exports.BrightcoveVideo = function (props) {
    var _a = react_1.useState(null), player = _a[0], setPlayer = _a[1];
    var _b = react_1.useState(null), meta = _b[0], setMeta = _b[1];
    var videoRef = react_1.useRef(null);
    react_1.useEffect(function () {
        brightcove_service_1.default.getVideo(props.videoId).then(function (data) {
            setMeta(patchMeta(data));
        });
    }, [props.videoId]);
    react_1.useEffect(function () {
        if (!player || !meta) {
            return;
        }
        player.src(meta.sources);
        player.poster(props.image ? getPoster(props.image, player) : meta.poster);
        if (meta.text_tracks) {
            meta.text_tracks.forEach(function (track) {
                if (track.srclang) {
                    var source = track.sources.find(function (s) {
                        return s.src.startsWith('https');
                    });
                    player.addRemoteTextTrack({
                        src: source ? source.src : track.src,
                        srclang: track.srclang,
                        kind: 'captions',
                    }, false);
                }
            });
        }
    }, [meta, player]);
    react_1.useEffect(function () {
        if (!videoRef.current) {
            return;
        }
        video_js_1.default(videoRef.current, {
            controls: true,
            controlBar: {
                children: [
                    { name: 'liveDisplay' },
                    { name: 'playToggle' },
                    { name: 'currentTimeDisplay' },
                    { name: 'timeDivider' },
                    { name: 'durationDisplay' },
                    { name: 'progressControl' },
                    { name: 'volumeMenuButton' },
                    { name: 'captionsButton' },
                    { name: 'fullscreenToggle' },
                ],
            },
            textTrackSettings: false,
            preload: 'auto',
            autoplay: 'play',
        }, function () {
            // @ts-ignore
            setPlayer(this);
            // TODO: Remove this workaround when CC menu will have fixed in video.js
            // @ts-ignore
            this.on('play', function (plr) {
                var target = plr.target;
                var captionsButton = target.querySelector('button.vjs-captions-button');
                var captionDiv = target.querySelector('div.vjs-captions-button');
                if (captionsButton) {
                    captionsButton.remove();
                }
                if (captionDiv) {
                    captionDiv.removeEventListener('mouseover', captionsDivListener);
                    captionDiv.removeEventListener('touchstart', captionsDivListener);
                    captionDiv.addEventListener('mouseover', captionsDivListener);
                    captionDiv.addEventListener('touchstart', captionsDivListener);
                }
            });
            // @ts-ignore
            this.on('ended', function () {
                props.videoPageStore.activateNextCard();
            });
        });
    }, []);
    return (react_1.default.createElement("div", { className: 'c-brightcove-video' },
        react_1.default.createElement("video", { ref: videoRef, className: 'video-js vjs-default-skin', autoPlay: true, crossOrigin: 'anonymous' })));
};
